import { render } from "./HomeText.vue?vue&type=template&id=0efef865&scoped=true"
import script from "./HomeText.vue?vue&type=script&lang=js"
export * from "./HomeText.vue?vue&type=script&lang=js"

import "./HomeText.vue?vue&type=style&index=0&id=0efef865&scoped=true&lang=css"

import exportComponent from "/home/arjun/Documents/Projects/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efef865"]])

export default __exports__